export enum EnumContactType {
  Phone = "Phone",
  Email = "Email",
  Mobile = "Mobile",
  Url = "Url",
}
